<template>
      <div class="modal is-active">
      <div class="modal-background"></div>
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">
              <slot name="header"></slot>
            </p>
            <button class="delete" aria-label="close" @click="$emit('close')"></button>
          </header>
          <section class="modal-card-body">
            <slot></slot>
          </section>
          <footer class="modal-card-foot">
            <slot name="footer" >
              <button class="button" @click="$emit('close')">关闭</button>
            </slot>
          </footer>
        </div>
    </div>
</template>

<script>
export default {
  name: "modal",
  props: { showModal: false },
  data() {
    return {};
  },
  created() {},
  methods: {}
};
</script>

<style scoped lang="css">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease-out;
}
.fade-enter-active .modal-card,
.fade-leave-active .modal-card {
  transition: transform 0.2s ease-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.fade-enter .modal-card,
.fade-leave-to .modal-card {
  transform: scale(0.9);
}
</style>



// WEBPACK FOOTER //
// src/components/modal.vue